// OattNspAndVendorInfoPage.tsx
import { Collapse, Spin } from 'antd';
import PageLayout from '@components/layout/PageLayout';
import { useOattVendorList } from '@hooks/useOattVendorList'; // Updated hook
import { VendorPanel } from './VendorPanel';
import styles from './OattNspAndVendorInfoPage.module.css';

const OattNspAndVendorInfoPage = () => {
    const { data: vendors, loading: vendorsLoading, refetch: refetchVendors } = useOattVendorList();

    const items = [

        ...(vendors ?? []).map((vendor: any) => ({
            key: `vendor-${vendor.oatt_vendor_info_id}`,
            label: <span className={styles.panelHeader}>{vendor.customer_code ?? vendor.company_name}</span>,
            children: <VendorPanel vendor={vendor} onSaved={refetchVendors} />,
        })),
    ];

    return (
        <PageLayout title="Vendor Info">
            {vendorsLoading ? (
                <Spin />
            ) : (
                <Collapse
                    accordion={false}
                    items={items}
                    className={styles.collapse}
                    bordered={false}
                />
            )}
        </PageLayout>
    );
};

export default OattNspAndVendorInfoPage;